import { NavigationState } from "../../types";

export const resetHistory = (
  state: NavigationState
) => {
  state.history = {};
};
